const MAX_FILE_NAME_LENGTH = 50;

export const getFileDisplayName = (fileName) => {
	if (fileName?.length > MAX_FILE_NAME_LENGTH) {
		return `${fileName.substring(0, MAX_FILE_NAME_LENGTH - 3)}...`;
	}
	return fileName;
};

export const removeFileFromSelection = (files, fileToRemove) =>
	files.filter(
		(file) => file.id !== fileToRemove.id || file.name !== fileToRemove.name,
	);
